"use client";

import React, { useDeferredValue, useEffect, useRef, useState } from "react";
import { useSiteSearchContext } from "../SiteSearchContext";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Collapse,
  Icon,
  InputAdornment,
  Slider,
  SliderValueLabelProps,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Arrow2LeftIcon from "@/app/_components/Icons/Arrow2LeftIcon";
import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import { NumericFormatToman } from "@/app/_components/NumericFormatToman";
import { useDebounce } from "use-debounce";

function ValueLabelComponent(props: SliderValueLabelProps) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={<Typography variant="body2">{value.toLocaleString()} تومان</Typography>}>
      {children}
    </Tooltip>
  );
}

export default function PriceRangeSideFilter({ intiOpen }: { intiOpen?: boolean }) {
  const mounted = useRef(false);
  const { minPrice, maxPrice, handleMinPriceChange, handleMaxPriceChange } = useSiteSearchContext();
  const MAX = 2_000_000;
  const [minPriceValue, setMinPriceValue] = React.useState<number | null | undefined>(minPrice);
  const [maxPriceValue, setMaxPriceValue] = React.useState<number | null | undefined>(maxPrice);
  const [minPriceValueDebounce] = useDebounce<number | null>(minPriceValue || null, 900);
  const [maxPriceValueDebounce] = useDebounce<number | null>(maxPriceValue || null, 900);
  const [value2, setValue2] = React.useState([minPriceValue || 0, maxPriceValue || MAX]);
  useEffect(() => {
    // Set a timeout to delay the effect logic by 1 second (1000 ms)
    const timeoutId = setTimeout(() => {
      // Your delayed effect logic here
      if (!mounted.current) {
        mounted.current = true;
      }
    }, 1000);

    // Clean up the timeout if the component unmounts before it triggers
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (mounted.current) {
      handleMinPriceChange(minPriceValueDebounce && minPriceValueDebounce > 0 ? minPriceValueDebounce : null);
    }
  }, [minPriceValueDebounce]);
  useEffect(() => {
    if (mounted.current) {
      handleMaxPriceChange(maxPriceValueDebounce && maxPriceValueDebounce > 0 ? maxPriceValueDebounce : null);
    }
  }, [maxPriceValueDebounce]);

  const minDistance = 10;
  const handleChange2 = (event: Event, newValue: number | number[], activeThumb: number) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], 100 - minDistance);
        setValue2([clamped, clamped + minDistance]);
      } else {
        const clamped = Math.max(newValue[1], minDistance);
        setValue2([clamped - minDistance, clamped]);
      }
    } else {
      setValue2(newValue as number[]);
    }
  };
  const [open, setOpen] = useState(intiOpen ?? true);

  return (
    <>
      <Box
        sx={{
          borderRadius: 2,
        }}
      >
        <Card
          elevation={0}
          sx={{
            borderRadius: 0,
          }}
        >
          <CardActionArea
            onClick={(ev) => {
              setOpen((e) => !e);
              // handleScrollToChartsCommunity(ev);
            }}
            sx={{
              p: {
                md: 2,
                xs: 1,
              },
            }}
          >
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
              <Typography variant="subtitle1"> محدوده قیمت</Typography>
              <Icon color="secondary" fontSize="small">
                {!open ? <Arrow2LeftIcon /> : <Arrow2DownIcon />}
              </Icon>
            </Stack>
          </CardActionArea>
          <Collapse in={open}>
            <CardContent>
              <Stack spacing={{ xs: 1, sm: 1 }} sx={{ px: 1 }}>
                <Stack direction="row" gap={1} alignItems={"center"} justifyContent={"space-between"}>
                  <TextField
                    placeholder="از"
                    InputProps={{
                      inputComponent: NumericFormatToman as any,
                    }}
                    sx={{ minWidth: 80, maxWidth: 120 }}
                    dir={!minPriceValue ? "rtl" : "ltr"}
                    value={minPriceValue}
                    onChange={(e) => {
                      setMinPriceValue(e.target.value ? Number(e.target.value) : null);
                    }}
                    size="small"
                    variant="outlined"
                  />
                  <TextField
                    placeholder="تا"
                    InputProps={{
                      inputComponent: NumericFormatToman as any,
                    }}
                    sx={{ minWidth: 80, maxWidth: 120 }}
                    dir={!maxPriceValue ? "rtl" : "ltr"}
                    value={maxPriceValue}
                    onChange={(e) => {
                      setMaxPriceValue(e.target.value ? Number(e.target.value) : null);
                    }}
                    size="small"
                    variant="outlined"
                  />
                </Stack>
                {/* <Slider
                  step={1000}
                  value={value2}
                  max={MAX}
                  onChangeCommitted={(event: React.SyntheticEvent | Event, value: number | Array<number>) => {
                    if (Array.isArray(value)) {
                      const [min, max] = value;
                      if (min > 0) {
                        setMinPriceValue(min);
                      } else if (min === 0) {
                        setMinPriceValue(undefined);
                      }
                      if (max !== MAX) {
                        setMaxPriceValue(max);
                      } else {
                        setMaxPriceValue(undefined);
                      }
                    }
                  }}
                  slots={{
                    valueLabel: ValueLabelComponent,
                  }}
                  onChange={handleChange2}
                  // valueLabelFormat={valuetext}
                  valueLabelDisplay="auto"
                  color="secondary"
                /> */}
                <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
                  <Typography variant="body2">ارزان‌ترین</Typography>
                  <Typography variant="body2">گران‌ترین</Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Collapse>
        </Card>
      </Box>
    </>
  );
}
